import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getSchemes,
    getSchemeActive,
    createScheme,
    deleteScheme
}

function getSchemes(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/schemes`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getSchemeActive(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/schemes/active`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createScheme(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/schemes`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteScheme(schemeId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/schemes/${schemeId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}